export const demoWorkflow = [
  {
    step: 1,
    id: 'setup',
    title: 'Project Initialization',
    description: 'Establish the core creative pillars, client goals, and technical specs.',
    module: 'Shoot Brief',
    action: 'Define Vision',
    status: 'success'
  },
  {
    step: 2,
    id: 'curation',
    title: 'Creative Direction',
    description: 'Curate high-fidelity visual references to align the team on lighting and tone.',
    module: 'Moodboard',
    action: 'Sync References',
    status: 'success'
  },
  {
    step: 3,
    id: 'engineering',
    title: 'Shot Engineering',
    description: 'Deconstruct the vision into a granular list of focus frames and technical requirements.',
    module: 'Shot List',
    action: 'Map Frames',
    status: 'in-progress'
  },
  {
    step: 4,
    id: 'logistics',
    title: 'Logistics Orchestration',
    description: 'Inventory critical props, confirm crew call-times, and verify location permits.',
    module: 'Logistics',
    action: 'Audit Assets',
    status: 'pending'
  },
  {
    step: 5,
    id: 'session',
    title: 'Live Session Execution',
    description: 'Real-time tracking of shot progress during the production window.',
    module: 'Command Center',
    action: 'Monitor Live',
    status: 'pending'
  },
  {
    step: 6,
    id: 'delivery',
    title: 'Final Delivery',
    description: 'Review processed assets and export the final high-res gallery to the client.',
    module: 'Export Gallery',
    action: 'Ship Assets',
    status: 'pending'
  }
];

export const sampleProjects = [
  { id: 'PRJ-901', name: 'Desert Chrome', client: 'Vogue Tech', date: '2024-12-01', status: 'Draft', progress: 10 },
  { id: 'PRJ-902', name: 'Urban Echo', client: 'Nike Substrata', date: '2024-11-28', status: 'Confirmed', progress: 45 },
  { id: 'PRJ-884', name: 'Neon Nights', client: 'CyberWear', date: '2024-11-15', status: 'Live', progress: 66 },
];